var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_21327",
    x: 0,
    y: 0,
    width: 91,
    height: 91,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21322",
    "data-name": "Ellipse 21322",
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "#4f5b6d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5038",
    "data-name": "Group 5038",
    transform: "translate(-560 -222)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 560, 222)",
    filter: "url(#Ellipse_21327)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21327-2",
    "data-name": "Ellipse 21327",
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    transform: "translate(9 6)",
    fill: "#4f5b6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_50",
    "data-name": "Mask Group 50",
    transform: "translate(569 228)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21321",
    "data-name": "Ellipse 21321",
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_person_24px",
    d: "M33.077,33.077A14.538,14.538,0,1,0,18.538,18.538,14.534,14.534,0,0,0,33.077,33.077Zm0,7.269C23.372,40.346,4,45.216,4,54.884v7.269L47.615,72.7,62.153,54.884C62.153,45.216,42.781,40.346,33.077,40.346Z",
    transform: "translate(3.118 5.94)",
    fill: "#d2d5da"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user_avatar.a095d860619641f649cd9f7271658d12.svg";
export { ForwardRef as ReactComponent };